import { Draft } from '@reduxjs/toolkit';

import { IProductData } from '../../index';

function importSpreadsheetFailure(draft: Draft<IProductData>) {
  draft.importSpreadsheet.config.isLoading = false;
}

export default importSpreadsheetFailure;
